import { FC, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { useFetchErrorToast } from '../../utils/useFetchErrorToasts/useFetchErrorToast';
import Header from '../../common/Header/Header';
import {
  Page,
  TableWrapper,
} from '../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles';
import Table from '../../components/Table/Table';
import { useDays } from '../../services/day/day.service';
import { readOnlyLabelTableText } from '../../constants/GlobalTexts';

const Days: FC = () => {

  const gridRef = useRef<AgGridReact>(null);
  const { data, isError: daysError } = useDays(true);

  useFetchErrorToast([{ isError: daysError, label: 'Error fetching days', id: 'daysFetchError' }]);

  return (
    <>
      <Header breadcrumb={{ to: '/tables', label: 'All tables' }} title="Day" titleTestId={'DayPageTitle'}/>
      <Page>
        <TableWrapper>
          <Table
            rowData={data?.data}
            ref={gridRef}
            returnedRecords={data?.data?.length}
            readOnlyLabel={readOnlyLabelTableText}
            height={'100%'}
            columnDefs={[
              { field: 'dayNo', headerName: 'Day No.', flex: 0.5 },
              { field: 'statusNo', headerName: 'Status No.', flex: 0.5},
              { field: 'description', headerName: 'Description', flex: 2 },
              { field: 'dayMask', headerName: 'Day Mask', flex: 1 }
            ]}
            isSizeColumnsToFit={false}
          />
        </TableWrapper>
      </Page>
    </>
  );
};

export default Days;